import PersonAvatar from "@common-components/tasks/person-avatar/person-avatar";
import { userDisplayName } from "@common-models/user";
import { AugmentedBlueticksBoardUser, cellPersonListSelector } from "@common-reducers/BoardsSelectors";
import { useAppSelector } from "@common-reducers/hooks/store.hook";
import { PersonPickerValue } from "../person-picker-cell/person-picker-cell";
import { Avatar, AvatarGroup, Box, Stack, Tooltip } from "@mui/material";
import { memo } from "react";
interface Props {
    values: unknown[];
    boardId: string;
}
function PersonPickerSumCell({ values, boardId }: Props) {
    const personList: AugmentedBlueticksBoardUser[] = useAppSelector(state => cellPersonListSelector(state, (values ?? []) as PersonPickerValue[], boardId));
    const cellPersonList: AugmentedBlueticksBoardUser[] = personList.length > 0 ? personList : []

    const maxAvatars = 4;
    const extraUsers = cellPersonList.length > maxAvatars ? cellPersonList.slice(maxAvatars) : [];
    const extraUsersTooltip = cellPersonList.map((user: AugmentedBlueticksBoardUser) => userDisplayName(user.profile)).join(', ');

    const extraFilesTheme = {
        alignItems: "end",
        ".MuiAvatar-circular": {
            height: '20px',
            width: '20px',
            background: 'var(--color-primary)',
            color: 'white',
            fontSize: '10px',
        }
    }

    return (
        <Stack sx={{ position: "relative" }} alignItems={"center"} flexGrow={1} textAlign={"center"}>
              
              <Tooltip title={extraUsersTooltip} arrow placement="bottom" >
              <AvatarGroup max={maxAvatars} sx={extraFilesTheme}>
            {cellPersonList.slice(0, maxAvatars).map((person: AugmentedBlueticksBoardUser, i: number) => (
                <Box key={i}>
                    <PersonAvatar
                        size={22}
                        email={person?.email}
                        profileImg={person?.profile?.profileImg}
                        lastName={person?.lastName}
                        firstName={person?.firstName}
                    />
                </Box>
            ))}

            {extraUsers.length > 0 && (
                <Tooltip title={extraUsersTooltip} arrow placement="bottom" >
                    <Avatar>+{extraUsers.length}</Avatar>
                </Tooltip>
            )}
        </AvatarGroup>
        </Tooltip>
        </Stack>
    );
}

export default memo(PersonPickerSumCell)